/* eslint-disable global-require */
import type { LogoColor, LogoType } from '..';

export const logoIcon: Record<LogoColor, Record<LogoType, string>> = {
  light: {
    tipaw: require('./logo-tipaw-light.svg'),
    'tipaw-pro': require('./logo-tipaw-pro-light.svg'),
  },
  dark: {
    tipaw: require('./logo-tipaw-dark.svg'),
    'tipaw-pro': require('./logo-tipaw-pro-dark.svg'),
  },
  yellow: {
    tipaw: require('./logo-tipaw-pro-yellow.svg'),
    'tipaw-pro': require('./logo-tipaw-pro-yellow.svg'),
  },
};
